import { IncomingMessage } from 'http'
import { nanoid } from 'nanoid'
import Cookies from 'universal-cookie'

export const TT_COOKIE_NAME = 'tt_anonymous_id'

export const getSegmentTrackingId = (req?: IncomingMessage) => {
  let cookies = new Cookies()

  if (req) {
    cookies = new Cookies(req.headers.cookie)
  }

  let trackingId = cookies.get(TT_COOKIE_NAME) ?? cookies.get('ajs_anonymous_id')

  if (!trackingId) {
    /**
     * Potential first-time visitor. Assign a tracking ID and store it in a cookie so that we can continue
     * to use it even if they have an adblocker installed and therefore not getting the segment cookie set.
     */
    trackingId = nanoid(32)
    cookies.set(TT_COOKIE_NAME, trackingId, {
      httpOnly: false,
      path: '/',
      sameSite: 'strict',
      secure: process.env.NODE_ENV === 'production',
      maxAge: 60 * 60 * 24 * 365 // 1 year
    })
  }

  return trackingId
}
